import React,{useEffect, useState} from 'react'
import { useNavigate } from "react-router-dom";
import Header from './Header';

function UserDashboard() {
    const navigate = useNavigate();
    const [apiCall, setApiCall] = useState(0)

    function previewForm(){
        navigate('/preview')
    }
    useEffect(() => {
      if (apiCall == 0) {
        if(sessionStorage.getItem("user_id")==null){
          sessionStorage.removeItem("access_token");
          sessionStorage.removeItem("user_id");
          sessionStorage.removeItem("email_id")
          sessionStorage.removeItem("mobile_no")
          sessionStorage.removeItem("first_name")
          sessionStorage.removeItem("middle_name")
          sessionStorage.removeItem("last_name")
          sessionStorage.removeItem("reference_id")
          navigate("/")
        }
      }
      setApiCall(1)
    }, [apiCall])
  return (
    
    <>
    <Header/>
    <div className="main">
    
        <div className="container">
            <br/><br/>
        <div className="middle">
            <h5><span className="text-danger"><b>Note:-</b></span>Your application has been submitted, To preview form click on Preview Button. For further information please contact <a href="mailto:support.gstat@gstn.org.in">support.gstat@gstn.org.in</a></h5>
            <br/>
           
        </div>
        
          <button className="btn btn-dark" onClick={previewForm}>Preview</button>
        </div>
        <div className="footer">
            <p className="text-center"><b>Designed and developed by GSTN</b></p>
        </div>
    </div>
    </>
  )
}

export default UserDashboard